import { withBlockExtensions } from '@plone/volto/helpers';
import View from './View';
import { EventDetailProps } from './index';

interface EditProps {
  content: EventDetailProps;
  [key: string]: any; // Allow additional props that might be passed by Volto
}

const Edit = (props: EditProps) => {
  return (
    <>
      <View {...props} />
    </>
  );
};

export default withBlockExtensions(Edit);
